var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "info-icon",
    xmlns: "http://www.w3.org/2000/svg",
    width: 13,
    height: 30,
    viewBox: "0 0 65.43 155.17",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 24.625 0.15234375 A 2.9838242 2.9838242 0 0 0 22.101562 2.921875 A 3.028936 3.028936 0 0 0 25.064453 5.9824219 A 3.0096024 3.0096024 0 0 0 28.0625 3.0234375 A 2.9838242 2.9838242 0 0 0 24.625 0.15234375 z M 19.728516 7.9492188 L 19.728516 11.880859 L 22.271484 11.880859 L 22.271484 21.09375 L 19.728516 21.09375 L 19.728516 25 L 30.271484 25 L 30.271484 21.076172 L 27.744141 21.076172 L 27.744141 7.9492188 L 19.728516 7.9492188 z ",
    transform: "matrix(6.2068,0,0,6.2068,-122.455,0)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoIcon);
export default __webpack_public_path__ + "static/media/info-icon.a583a434ae28d1cbf4f142695db81da5.svg";
export { ForwardRef as ReactComponent };